import * as React from "react";
import { mapBPMPlaylist, mapPlaylist, mapUserPlaylist } from "src/transformer";
import { RouteComponentProps, Route, withRouter } from "react-router";
import { WithToast, BPMCurated, errorToString, resolveCurrentUrl, CuratedListView, Loader, withToast, CuratedDetail, UserContextType } from 'bpm-web-generic';
import { Switch } from "react-router-dom";
import { Analytics } from "src/manager/AnalyticsManager";
import { playlistAPI, userPlaylistAPI } from "src/api/config";
import { Playlist } from "src/api/download-api-sdk/src";

export interface PlaylistsProps extends RouteComponentProps<{ set?: string, mySet?: string; categorySlug?: string }>, WithToast {
    page: string;
}
interface PlaylistsState {
    sets?: { [key: number]: BPMCurated[] },
    categories?: { id: number, name: string }[],
    myPlaylists?: BPMCurated[]

    set?: BPMCurated;
}
class PlaylistsView extends React.Component<PlaylistsProps, PlaylistsState> {

    static contextType = UserContextType
    context!: React.ContextType<typeof UserContextType>

    constructor(props: PlaylistsProps) {
        super(props);
        this.context
        this.state = {

        }
    }

    componentDidMount() {
        this.loadPlaylists()
        if (this.props.match.params.set) {
            this.loadPlaylistForSlug().then(set => {
                Analytics.trackView('playlist', `${set.id}`)
            })
        } else if (this.props.match.params.mySet) {
            this.loadMyPlaylistForSlug()
        }
    }

    componentDidUpdate(prevProps: PlaylistsProps) {
        if (prevProps.match.params.set != this.props.match.params.set || prevProps.match.params.mySet != this.props.match.params.mySet) {
            this.setState({ set: undefined }, () => {
                if (this.props.match.params.set) {
                    this.loadPlaylistForSlug().then(set => {
                        Analytics.trackView('playlist', `${set.id}`)
                    })
                } else if (this.props.match.params.mySet) {
                    this.loadMyPlaylistForSlug()
                }
            })
        }
    }

    private loadMyPlaylistForSlug() {
        userPlaylistAPI.getUserPlaylistSet(this.props.match.params.mySet!).then(({ data }) => {
            this.setState({ set: mapUserPlaylist(data) })
            Analytics.trackView('forYou', data.id)
        }).catch(err => {
            errorToString(err).forEach(error => {
                this.props.showToast('danger', error)
            }, () => {
                this.loadMyPlaylistForSlug()
            })
        })
    }

    private loadPlaylistForSlug() {
        return playlistAPI.getPlaylistSetBySlug(this.props.match.params.set!).then(({ data }) => {
            this.setState({ set: mapBPMPlaylist(data) })
            Analytics.trackView('playlist', `${data.id}`)
            return data
        }).catch(err => {
            return new Promise<Playlist>((resolve) => {
                errorToString(err).forEach(error => {
                    this.props.showToast('danger', error)
                }, () => {
                    resolve(this.loadPlaylistForSlug())
                })
            })

        })
    }

    private loadPlaylists() {
        playlistAPI.getPlaylistSets(undefined, undefined, 'music').then(({ data }) => {
            const categories = data.map((d) => d.category).unique('id')
            const final_sets: { [key: number]: BPMCurated[] } = {}

            data.forEach((set) => {
                if (!final_sets[set.category.id.toString()]) {
                    final_sets[set.category.id.toString()] = []
                }
                final_sets[set.category.id.toString()].push(mapPlaylist(set))
            })
            this.setState({
                categories: categories, sets: final_sets
            })
        }).catch(err => {
            errorToString(err).forEach(error => {
                this.props.showToast('danger', error)
            }, () => {
                this.loadPlaylists()
            })
        })
    }

    private navigateToSet(set: BPMCurated) {
        this.props.history.push('/' + resolveCurrentUrl(this.props.page, set.slug))
    }

    private navigateToPlaylist(set: BPMCurated) {
        this.props.history.push(resolveCurrentUrl(this.props.page, 'forYou/' + set.id as string))
    }

    private renderSetDetail() {
        if (this.state.set) {
            const featured = Object.keys(this.state.sets || {}).reduce((previous, current) => {
                this.state.sets![current].forEach((curated: BPMCurated) => {
                    if (curated.featured) {
                        previous.push(curated)
                    }
                })
                return previous;
            }, new Array<BPMCurated>())
            return <div>
                <CuratedDetail {...this.props} set={this.state.set} shareType={'hash'} />
                {featured.length > 0 && <CuratedListView sets={featured} title={'Featured'} onClick={(set) => {
                    this.navigateToSet(set)
                }} style={{ paddingTop: '40px' }} />}
            </div>
        } else {
            return <Loader />
        }
    }

    public render() {
        if (!this.state.categories) {
            return <Loader />
        } else {
            if (this.props.match.params.set || this.props.match.params.mySet) {
                return this.renderSetDetail()
            }
            return <div>
                {this.state.categories.filter(category => {
                    if (this.props.match.params.categorySlug) {
                        return category.name.toLowerCase() == this.props.match.params.categorySlug.toLowerCase().replace(/--/g, '{ʥ}').replace(/-/g, ' ').replace(/{ʥ}/g, '-')
                    }
                    return true
                }).map(category => {
                    return <CuratedListView sets={this.state.sets![category.id.toString()]} title={category.name} key={category.id} onClick={(set) => {
                        this.navigateToSet(set)
                    }} style={{ paddingBottom: '40px' }} />
                })}
                {this.state.myPlaylists && this.state.myPlaylists.length > 0 &&
                    <CuratedListView sets={this.state.myPlaylists} title={'My Playlists'} key={'my_playlists-key'} onClick={(set) => {
                        this.navigateToPlaylist(set)
                    }} style={{ paddingBottom: '40px' }} />
                }
            </div>
        }
    }
}
const CSD = withToast(PlaylistsView)
export default withRouter(class CuratedSetViewRouted extends React.Component<RouteComponentProps<{ page: string }>> {
    public render() {
        return <Switch>
            <Route path={resolveCurrentUrl(this.props.match.url, '/mySet/:mySet')} render={(p) => {
                return <CSD {...this.props} {...p} page={this.props.match.params.page} />
            }} />
            <Route path={resolveCurrentUrl(this.props.match.url, '/forYou/:mySet')} render={(p) => {
                return <CSD {...this.props} {...p} page={this.props.match.params.page} />
            }} />
            <Route path={resolveCurrentUrl(this.props.match.url, '/category/:categorySlug')} render={(p) => {
                return <CSD {...this.props} {...p} page={this.props.match.params.page} />
            }} />
            <Route path={resolveCurrentUrl(this.props.match.url, '/:set?')} render={(p) => {
                return <CSD {...this.props} {...p} page={this.props.match.params.page} />
            }} />
        </Switch>

    }
})


// WEBPACK FOOTER //
// ./src/pages/Playlists.tsx